// test2948
(2948 && 0);
